export enum DateFormatEnum {
  MDY = 'MMM DD, YYYY',
  DMYD = 'DD-MM-YYYY',
  YMD = 'YYYY-MM-DD',
  MDYT = 'MMM DD, YYYY HH:mm',
  ISO = 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  DMY = 'DD MMM, YYYY',
  DM = 'DD MMMM',
  MD = 'MMMM DD',
  MY = 'MMMM YYYY',
  YYYY = 'YYYY',
}
